/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientResource } from '../models/ClientResource';
import type { DevisResource } from '../models/DevisResource';
import type { ProjetResource } from '../models/ProjetResource';
import type { RdvResource } from '../models/RdvResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SpaceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Envoyer un code de connexion par SMS
     * Premiere etape de la connexion a l'espace client : envoie un code a usage unique au numero `PORTABLE`. Le code se verifie ensuite avec `space/verifyOtpAndCreateToken`.
     * @param portable
     * @returns string
     * @throws ApiError
     */
    public spaceGenerateOtp(
        portable: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/generateOtp',
            query: {
                'PORTABLE': portable,
            },
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Verifier le code et obtenir un token client
     * Seconde etape de la connexion : `IDCLIENT`, `PORTABLE` et le `CODE` recu par SMS. Renvoie un token client (`{ token, tokenable_type, tokenable_id, company_id }`) a passer ensuite en `Authorization: Bearer` sur les endpoints `/space*`. Un code faux ou expire renvoie une erreur de validation.
     * @param idclient
     * @param portable
     * @param code
     * @returns any
     * @throws ApiError
     */
    public spaceVerifyOtpAndCreateToken(
        idclient: string,
        portable: string,
        code: string,
    ): CancelablePromise<{
        token: string;
        tokenable_type: string;
        tokenable_id: string;
        company_id: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/verifyOtpAndCreateToken',
            query: {
                'IDCLIENT': idclient,
                'PORTABLE': portable,
                'CODE': code,
            },
            errors: {
                400: `Header Company-Key absent.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Fiche du client connecte
     * Avec son adresse et son agence. Le client est celui du token : aucun parametre.
     * @returns ClientResource `ClientResource`
     * @throws ApiError
     */
    public spaceGetClientDetails(): CancelablePromise<ClientResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/client',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Rendez-vous a venir
     * Tous les rendez-vous futurs du client, sur l'ensemble de ses projets, avec leur adresse.
     * @returns RdvResource Array of `RdvResource`
     * @throws ApiError
     */
    public spaceNextRdvs(): CancelablePromise<Array<RdvResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/rdv',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Devis en attente de signature
     * Les devis transmis au client et pas encore signes, du plus recent au plus ancien.
     * @returns DevisResource Array of `DevisResource`
     * @throws ApiError
     */
    public spaceNextDevisEnAttente(): CancelablePromise<Array<DevisResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/devis_attente',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Projets du client connecte
     * Tous ses projets, avec l'adresse de chantier et le commercial en charge, du plus ancien au plus recent.
     * @returns ProjetResource Array of `ProjetResource`
     * @throws ApiError
     */
    public spaceGetProjectsList(): CancelablePromise<Array<ProjetResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/project',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Devis d'un projet
     * Les devis non refuses du projet, du plus recent au plus ancien. 404 si le projet n'appartient pas au client connecte.
     * @param idProjet
     * @returns DevisResource Array of `DevisResource`
     * @throws ApiError
     */
    public spaceGetDevisList(
        idProjet: string,
    ): CancelablePromise<Array<DevisResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/project/{id_projet}',
            path: {
                'id_projet': idProjet,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Detail d'un devis ou d'une commande
     * Avec l'intervention planifiee, les factures et les rendez-vous lies. 404 si le devis n'appartient pas au client connecte.
     * @param idDevis
     * @returns DevisResource `DevisResource`
     * @throws ApiError
     */
    public spaceGetDevisDetails(
        idDevis: string,
    ): CancelablePromise<DevisResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/devis/{id_devis}',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Fichiers d'un devis
     * Les documents rattaches au devis (devis, conditions generales, plans...), chacun avec une `url` de telechargement temporaire. 404 si le devis n'appartient pas au client connecte.
     * @param idDevis
     * @returns string
     * @throws ApiError
     */
    public spaceGetDevisFiles(
        idDevis: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/devis/{id_devis}/files',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Signer un devis
     * Signature electronique par le client : `NOM_SIGNATAIRE`, `PORTABLE` et le `CODE` recu par SMS (envoye via `space/generateOtp`). Le devis doit appartenir au client et ne pas etre refuse.
     *
     * Reponse : `{ message, signed_at, files_signed }`. Toute erreur renvoie 400 avec son message.
     * @param idDevis
     * @param nomSignataire
     * @param portable
     * @param code
     * @returns any
     * @throws ApiError
     */
    public spaceSignDevis(
        idDevis: string,
        nomSignataire: string,
        portable: string,
        code: string,
    ): CancelablePromise<{
        message: string;
        signed_at: string;
        files_signed: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/space/devis/{id_devis}/sign',
            path: {
                'id_devis': idDevis,
            },
            query: {
                'NOM_SIGNATAIRE': nomSignataire,
                'PORTABLE': portable,
                'CODE': code,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Envoyer un e-mail de confirmation
     * Envoie un e-mail depuis l'espace client avec les champs fournis (destinataire, sujet, contenu).
     * @returns any
     * @throws ApiError
     */
    public spaceSendMailConfirm(): CancelablePromise<{
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/space/mail/send',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
